export default __webpack_public_path__ + "static/1.1_IT-e01225e35cded94265fdd82f45d10cc0.webp";